export const NO_DATE = "2026-12-01";
